import { render, staticRenderFns } from "./SampleList.vue?vue&type=template&id=384144bf&scoped=true"
import script from "./SampleList.vue?vue&type=script&lang=js"
export * from "./SampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384144bf",
  null
  
)

export default component.exports